import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { captureSensitiveUrlParams } from './app/core/services/sensitive-url-params';

// Credentials from e-mail links (?t= / ?token= on the request board, guest
// dashboard and chat) move to the in-memory holder and leave the address bar
// BEFORE the app (and with it any analytics tracker reading location.href)
// starts. Request-board ones also keep a per-tab sessionStorage copy, restored
// here after a reload (F5) of the cleaned URL — never put back into the URL.
captureSensitiveUrlParams();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
